/* tslint:disable */
require('./LookupRenderer.module.css');
const styles = {
  ellipsis: 'ellipsis_6129a9c2',
  relative: 'relative_6129a9c2',
  fabricIcon: 'fabricIcon_6129a9c2',
  lookup: 'lookup_6129a9c2',
};

export default styles;
/* tslint:enable */